var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.header'] = (function () {
    'use strict';

    const initialize = (component) => {
        App.Helpers.initializeRoutingCopy(component);
        initializeSearchFocus(component);
    };

    // Moves focus into the search input once the search drawer has finished opening.
    const initializeSearchFocus = (component) => {
        const drawer = component.querySelector('#header-offcanvas-search');
        const input = drawer?.querySelector('#SiteSearch_Header');
        if (!input) return;

        drawer.addEventListener('shown.bs.offcanvas', () => input.focus());
    };

    return {
        initialize
    };
})();